import { render, staticRenderFns } from "./CompanyContactsCard.vue?vue&type=template&id=8b9ff072&"
import script from "./CompanyContactsCard.vue?vue&type=script&lang=js&"
export * from "./CompanyContactsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports